const Wayfinder = () => {
  if (!document.querySelector(".wayfinder-tab__button")) {
    return;
  }

  const ACTIVE_BUTTON = "wayfinder-tab__button--active";
  const ACTIVE_TAB = "wayfinder-tab--active";
  const MOBILE_SIZE = 750;

  document.querySelectorAll(".wayfinder-tab__button").forEach((button) => {
    button.addEventListener("click", (e) => {
      e.preventDefault();

      if (button.classList.contains(ACTIVE_BUTTON)) {
        return false;
      }

      document.querySelectorAll(".wayfinder-tab__button").forEach((button) => {
        button.classList.remove(ACTIVE_BUTTON);
      });

      button.classList.add(ACTIVE_BUTTON);

      const tab = document.getElementById(button.getAttribute("aria-controls"));

      if (tab) {
        document.querySelectorAll(".wayfinder-tab").forEach((tab) => {
          tab.classList.remove(ACTIVE_TAB);

          // prevent tabbing on it
          tab.setAttribute("tabindex", "-1");
        });

        tab.classList.add(ACTIVE_TAB);

        // allow tabindex on it
        tab.removeAttribute("tabindex");
        tab.querySelector("a").focus();

        // save state to local storage
        localStorage.setItem(
          "wayfinder-tab",
          button.getAttribute("aria-controls")
        );
      }
    });
  });

  // load the selected tab from local storage
  const selectedTab = localStorage.getItem("wayfinder-tab");

  if (selectedTab) {
    const button = document.querySelector(`[aria-controls="${selectedTab}"]`);

    if (button) {
      button.click();
    } else {
      // if the tab doesn't exist, select the first one
      if (window.innerWidth > MOBILE_SIZE) {
        document.querySelector(".wayfinder-tab__button").click();
      }
    }
  } else {
    // if no tab is selected, select the first one as long as we're not on
    // mobile
    if (window.innerWidth > MOBILE_SIZE) {
      document.querySelector(".wayfinder-tab__button").click();
    }
  }

  // on clicking .wayfinder-tab__title on mobile, toggle the tab
  document.querySelectorAll(".wayfinder-tab__trigger").forEach((trigger) => {
    trigger.addEventListener("click", (e) => {
      e.preventDefault();
      const tab = trigger.closest(".wayfinder-tab");

      if (tab) {
        tab.classList.toggle(ACTIVE_TAB);

        if (tab.classList.contains(ACTIVE_TAB)) {
          localStorage.setItem("wayfinder-tab", tab.id);
        } else {
          // clear
          localStorage.removeItem("wayfinder-tab");
        }
      }
    });
  });
};

export default Wayfinder;
